module.exports = __webpack_public_path__ + "static/media/xiangshan_plant.d7364732.png";